/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Overage_Alert_Threshold_HintInputs */



/**
* | output |
* | --- |
* | "We email admins when overage usage reaches this percentage." |
*
* @param {Usage_Overage_Alert_Threshold_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_alert_threshold_hint = /** @type {((inputs?: Usage_Overage_Alert_Threshold_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Alert_Threshold_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wir benachrichtigen Admins per E-Mail, wenn der Überschussverbrauch diesen Prozentsatz erreicht.")
	return /** @type {LocalizedString} */ ("We email admins when overage usage reaches this percentage.")
});